import React, { useContext, useEffect, useState } from "react";
import { GeneralSetting } from "../../components/profile-comp/notification/GeneralSetting";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import { Spinner } from "../../Spinner";
import useDirection from "../../hooks/useDirection";

const Settings = () => {
  const { theme, langMode } = useContext(AppContext);
  const { dir } = useDirection();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="page-stack w-full" dir={dir}>
      {loading && <Spinner />}
      <h4
        className={`page-title ${theme === "dark"
          ? "dark-mode "
          : theme === "high-contrast"
            ? "high-contrast  "
            : ""
          }`}
      >
        {translations[langMode].setting}
      </h4>
      <div
        className={`page-stack bg-white ${theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          }`}
      >
        <div className="page-stack w-full">
          <GeneralSetting />
        </div>

      </div>
    </div>
  );
};
export default Settings;
